import { useQuery } from '@tanstack/react-query';
import { queryClient as globalQueryClient } from 'src/store/store';
import useProjectSystem from '../systems/useProjectSystem';
import { QueryFilters, QueryKeys } from './queryKeys';
import { DEFAULT_QUERY_OPTIONS } from './constants';

const useFetchIncludedFeaturesQuery = ( projectID: number ) => {
	const system = useProjectSystem();

	return useQuery(
		QueryKeys.forIncludedFeatures( projectID ),
		() => system.fetchIncludedFeatures( projectID ),
		// Stale time of 12 hours since we don't expect frequent changes
		// on the result of the query.
		{ ...DEFAULT_QUERY_OPTIONS, staleTime: 1000 * 3600 * 12 }
	);
};

export const invalidateProjectIncludedFeaturesQuery = ( projectID?: number ) => {
	globalQueryClient.invalidateQueries( {
		...QueryFilters.forIncludedFeatures( projectID ),
		refetchType: 'active'
	} );
}

export default useFetchIncludedFeaturesQuery;
